import React from "react";
import { useTranslation } from "react-i18next";

import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/styles";

import AktyCard from "./AktyCard";

const useStyles = makeStyles((theme) => ({
    AccordionRoot: {
        // border: `1px solid ${alpha(theme.palette.primary.main, 0.125)}`,
        border: `1px solid transparent`,
        boxShadow: "none",
        padding: 0, //theme.spacing(0, 2),
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    expanded: {},
    AccordionSummaryRoot: {
        borderBottom: "1px solid #ECECEC",
        marginBottom: -1,
        minHeight: "32px!important",
        "&$expanded": {
            minHeight: 32,
        },

        "&$AccordionSummaryContentExpanded": {
            // backgroundColor: "#FAFAFA",
        },
    },
    AccordionSummaryContent: {
        margin: `${theme.spacing(1, 0)}!important`,
    },
    AccordionSummaryContentExpanded: {
        "& $AccordionSummaryTitle": {
            fontWeight: 400,
            
        },
    },
    AccordionSummaryTitle: {
        fontSize: "clamp(14px, 1vw, 1.25rem)",
        fontWeight: 400,
        paddingLeft: 8,
        transition: "padding-left 0.5s linear",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: 0,
        },
    },
    AccordionDetailsRoot: {
        padding: theme.spacing(2, 2, 0, 7),
        // marginLeft: 22,
        // borderLeft: "1px solid #ECECEC",
        [theme.breakpoints.down("sm")]: {
            // marginLeft: 8,
            padding: theme.spacing(2, 2, 0, 3),
        },
    },
    card: {
        height: "100%",
    },
    cardHeaderRoot: {
        backgroundColor: alpha(theme.palette.primary.main, 0.0675),
    },
    cardHeaderTitle: {
        fontSize: "0.8rem",
        fontWeight: theme.typography.fontWeightMedium,
    },
    focusVisible: {
        backgroundColor: `${alpha(theme.palette.primary.main, 0.025)}!important`,
    },
    aktCard: {
        position: "relative",
        borderBottom: "1px dashed #00000011",
        "&:nth-child(even)": {
            backgroundColor: "#FAFAFA",
        },
    },
}));

const AktyAccordion = ({ id_cechy, akty, expanded, onExpand, isMobile }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const handleChange = (panel) => (event, newExpanded) => {
        onExpand && onExpand(panel);
    };

    return (
        <>
            <Accordion
                square
                expanded={expanded.includes(`akt-${id_cechy}`)}
                onChange={handleChange(`akt-${id_cechy}`)}
                classes={{ root: classes.AccordionRoot }}
            >
                <AccordionSummary
                    aria-controls={`akt-${id_cechy}-content`}
                    id={`akt-${id_cechy}-header`}
                    expandIcon={<ExpandMoreIcon color={"primary"} fontSize={"small"} />}
                    classes={{
                        root: classes.AccordionSummaryRoot,
                        content: classes.AccordionSummaryContent,
                        expanded: classes.AccordionSummaryContentExpanded,
                        focusVisible: classes.focusVisible,
                    }}
                >
                    <Typography className={classes.AccordionSummaryTitle}>
                        {t("cecha.akty")}
                        <small>({akty.length})</small>:
                    </Typography>
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.AccordionDetailsRoot }}>
                    <Grid container spacing={5} style={{ marginBottom: 0 }}>
                        {akty.map((akt) => {
                            return (
                                <Grid
                                    item
                                    xs={12}
                                    md={akty?.length > 1 ? 6 : 12}
                                    key={akt.id_akt}
                                    className={classes.aktCard}
                                >
                                    <AktyCard akt={akt} noTitle={true} />
                                </Grid>
                            );
                        })}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default AktyAccordion;
